import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import React, { FC, useMemo } from 'react';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Image } from '../../../components/Image';
import { ACCOUNT_TAB } from '../constants';
import { FONTS } from '../../../constants';

interface TabBarProps {
  current?: number;
}

const TabBar: FC<TabBarProps> = ({ current = 0 }) => {
  const renderButton = useMemo(() => {
    return ACCOUNT_TAB.map((content, index) => (
      <TouchableOpacity
        style={[styles.button]}
        onPress={() => {
          content.onPress();
        }}
        key={content.title}
      >
        <Image
          source={content.icon}
          style={{
            width: 20,
            height: 20,
            marginBottom: 10,
            resizeMode: 'contain',
            tintColor: STYLE_VARS.primaryColor,
          }}
        />
        <Text
          style={[
            styles.textStyled,
          ]}
        >
          {content.title}
        </Text>
      </TouchableOpacity>
    ));
  }, []);

  return <View style={styles.wrapper}>{renderButton}</View>;
};

export default TabBar;

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    backgroundColor: STYLE_VARS.fccLightGrey,
  },
  button: {
    width: '25%',
    paddingHorizontal: 8,
    paddingVertical: 15,
    alignItems: 'center',
  },
  textStyled: {
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 10,
    fontWeight: '500',
    alignItems: 'center',
    textAlign: 'center',
  },
});
